<template>
  <div class="fill-height"
    :style="[
      {'background-image': `url('${require('@/assets/background-login.jpg')}')`},
      {'background-repeat': 'repeat'}
    ]"
  >
    <strategio-app-bar></strategio-app-bar>
    <v-content style="height:100vh">
      <div style="height:100%; overflow:auto">
        <v-layout justify-center column class="strategio-admin-users-main-container">
          <users-list></users-list>
          <div
            class="strategio-speed-dial"
          >
            <v-btn
              id="adduser-button"
              fixed
              dark
              fab
              bottom
              right
              color="red"
              @click="goToCreateUser()"
            >
              <v-icon>add</v-icon>
            </v-btn>

          </div>
        </v-layout>

      </div>

    </v-content>
    <custom-snack-bar></custom-snack-bar>
  </div>
</template>

<script>
import eventBus from '../utils/eventBus'
import introBus from '../utils/introBus'

import StrategioAppBar from '../components/header-bar/strategio-app-bar.vue'
import UsersList from '../components/users/users-list.vue'

import CustomSnackBar from '../components/snackbars/custom-snack-bar.vue'

export default {
  name: 'user-admin',
  mounted () {
    eventBus.$off('start-user-admin-tutorial')
    eventBus.$on('start-user-admin-tutorial', () => {
      let intro = introBus.getIntroBus()
      intro.addSteps([
        {
          element: '#usersfilter-textfield',
          intro: 'Filtro para usuarios existentes'
        },
        {
          element: '#userlistitem0',
          intro: 'Estos son los usuarios agregados o filtrados. Se puede apreciar el nivel de permisos, nombre y correo del usuario'
        },
        {
          element: '#adduser-button',
          intro: 'Con este botón es posible agregar usuarios nuevos'
        }
      ].filter((obj) => {
        return document.getElementById(obj.element.split('#')[1])
      }))
      intro.start()
    })
  },
  methods: {
    goToCreateUser () {
      this.$router.push('/user/admin-create')
    }
  },
  components: {
    StrategioAppBar,
    UsersList,
    CustomSnackBar
  }
}
</script>
<style>
.strategio-admin-users-main-container {
  margin-top: 24px !important;
  margin-bottom: 84px !important;
}
</style>



// WEBPACK FOOTER //
// src/routes/user-admin.vue